import React, { FC } from 'react'
import cx from 'classnames'

import { LinkProps } from '../../Link'

import * as SC from './styled'

export type FooterContactProps = {
  className?: string
  title: string
  phone: string
  address: string
  contactUsCta: LinkProps
}

const FooterContact: FC<FooterContactProps> = (props) => {
  const { className, title, phone, address, contactUsCta } = props

  return (
    <SC.Container className={cx(className)}>
      <SC.Column>
        <SC.Title>{title}</SC.Title>
        <SC.Markdown text={address} />
        <SC.Markdown text={phone} />
        <SC.ContactUsCta {...contactUsCta} />
      </SC.Column>
    </SC.Container>
  )
}

export default FooterContact
